module.exports = __webpack_public_path__ + "img/travel.8c5be5d6.svg";